// ── 홍보물 관리 — CSS-in-JS 스타일 상수 ─────────────────────────────────────
// 2026-08-27 디자인 통일: 직원 관리 기준 (designStandard.js) — 본문 그림자 제거·1px 테두리·검정 머리글 띠
// 2026-08-31 모달 헤더 표준: 검정 밴드 + 아이콘 박스 + 흰 제목 + X (stdModalHeader*)
import {
  stdBlackBtn, stdOutlineBtn,
  stdModalHeaderBar, stdModalHeaderIconBox, stdModalHeaderTitle, stdModalCloseBtn,
} from '../adminlayout/designStandard';
export const overlayStyle = {
  position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 2000,
  display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
  boxSizing: 'border-box',
};
export const modalBoxStyle = {
  background: 'var(--bg-card)', borderRadius: 16,
  width: 'min(640px, calc(100vw - 24px))',
  maxWidth: 'calc(100vw - 24px)',
  maxHeight: 'min(90vh, calc(100dvh - 24px))', display: 'flex', flexDirection: 'column',
  overflow: 'hidden',
  boxSizing: 'border-box',
  boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
};
// 모달 헤더 — 검정 밴드 표준 (modalBoxStyle 라운드 16 에 맞춤)
export const modalHeaderStyle = { ...stdModalHeaderBar(16) };
// 헤더 왼쪽 아이콘 박스 + 흰 제목 (표준 토큰 재노출 — 사용처는 이 파일에서 import)
export const modalHeaderIconBox = stdModalHeaderIconBox;
export const modalHeaderTitleStyle = stdModalHeaderTitle;
export const closeBtnStyle = { ...stdModalCloseBtn };
export const modalBodyStyle = {
  padding: '16px 20px', overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: 12,
  minWidth: 0, overflowX: 'hidden', boxSizing: 'border-box',
};
export const modalFooterStyle = {
  padding: '12px 20px', borderTop: '1px solid var(--bg-subtle)',
  display: 'flex', justifyContent: 'flex-end', gap: 8, flexShrink: 0,
};
export const sectionCard = {
  background: 'var(--bg-subtle)', borderRadius: 12, padding: '12px 14px',
  border: '1px solid var(--border)', display: 'flex', flexDirection: 'column', gap: 10,
  minWidth: 0, boxSizing: 'border-box',
};
export const sectionTitle = {
  fontSize: 12, fontWeight: 800, color: 'var(--text-sub)', marginBottom: 2,
};
export const twoCol = { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(220px, 100%), 1fr))', gap: 10, minWidth: 0 };
export const inputStyle = {
  width: '100%', padding: '7px 10px', borderRadius: 7, border: '1px solid var(--border)',
  fontSize: 12, background: 'var(--bg-card)', boxSizing: 'border-box', outline: 'none',
};
export const cancelBtnStyle = {
  border: '1.5px solid var(--border)', borderRadius: 8, padding: '7px 18px',
  background: 'var(--bg-card)', color: 'var(--text-sub)', fontWeight: 600, fontSize: 13, cursor: 'pointer',
};
export const savePurpleBtnStyle = {
  border: 'none', borderRadius: 8, padding: '7px 22px',
  background: 'linear-gradient(135deg,#7c3aed,#6d28d9)', color: '#fff',
  fontWeight: 700, fontSize: 13, cursor: 'pointer',
};
export const addItemBtnStyle = {
  border: '1.5px dashed #7c3aed', borderRadius: 8, padding: '6px 14px',
  background: 'var(--bg-subtle)', color: '#7c3aed', fontWeight: 700, fontSize: 12,
  cursor: 'pointer', width: '100%', marginTop: 2,
};
export const removeItemBtnStyle = {
  border: '1px solid #ef4444', borderRadius: 6, padding: '3px 8px',
  background: 'var(--bg-card)', color: '#dc2626', fontSize: 11, cursor: 'pointer', flexShrink: 0,
};

// 홍보물 금액 관리 모달 전용
export const dragHandleStyle = {
  width: 22, flexShrink: 0,
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  cursor: 'grab', color: 'var(--text-muted)', fontSize: 16,
  userSelect: 'none', lineHeight: 1,
};
export const itemHeaderRow = {
  display: 'flex', gap: 8, padding: '4px 0', borderBottom: '1px solid var(--border)',
  marginBottom: 6, fontSize: 11, fontWeight: 700, color: 'var(--text-muted)',
  minWidth: 0,
};
export const itemRow = {
  display: 'flex', gap: 8, alignItems: 'center', marginBottom: 4,
  minWidth: 0,
};
export const itemInput = {
  padding: '6px 8px', borderRadius: 6, border: '1px solid var(--border)',
  fontSize: 12, outline: 'none', boxSizing: 'border-box', minWidth: 0,
  background: 'var(--bg)', color: 'var(--text)',
};
export const addRowBtnStyle = {
  border: '1.5px dashed #7c3aed', borderRadius: 8, padding: '6px 14px',
  background: 'var(--bg-subtle)', color: '#7c3aed', fontWeight: 700, fontSize: 12,
  cursor: 'pointer', width: '100%', marginTop: 6,
};

// 페이지 헤더 버튼 — 디자인 표준: 보조=흰 외곽선, 주요=검정 박스
export const itemManageBtnStyle = { ...stdOutlineBtn };
export const newOrderBtnStyle = { ...stdBlackBtn };
// 주문 목록 상자 — 바깥 회색 테두리는 뺐다(2026-10-23 사용자: "홍보물 주문 목록 바깥 회색 테두리 없애주고").
//   좌우 안쪽 여백도 0 — 표·카드가 제목·검색칸과 같은 선에서 시작한다(출퇴근 관리와 같음, 2026-10-23 사용자 선택 a).
export const cardStyle = {
  background: 'var(--bg-card)', borderRadius: 8, border: 'none',
  boxShadow: 'none', padding: '16px 0',
};
export const cardHeaderStyle = {
  display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14,
};
export const cardTitleStyle = { fontSize: 14, fontWeight: 800, color: 'var(--text-sub)' };
export const emptyStyle     = { textAlign: 'center', padding: '32px 0', color: 'var(--text-muted)', fontSize: 13 };

// 행 상태 배경색 헬퍼 — 계약 관리와 동일한 패턴
// 라이트: 낮은 불투명도 / 다크: 높은 불투명도로 어두운 배경에서도 구분 가능
// 우선순위: allShipped(완료-녹색) > anyInProgress(진행중-노랑) > 기본
export function resolvePromoRowColors(allShipped, anyInProgress, isDark) {
  const d = isDark;
  if (allShipped)    return { bg: d ? 'rgba(22,163,74,0.22)' : 'rgba(22,163,74,0.07)', border: d ? 'rgba(22,163,74,0.50)' : 'rgba(22,163,74,0.25)', left: '#16a34a' };
  if (anyInProgress) return { bg: d ? 'rgba(234,179,8,0.22)' : 'rgba(234,179,8,0.07)', border: d ? 'rgba(234,179,8,0.50)' : 'rgba(234,179,8,0.25)', left: '#d97706' };
  return { bg: 'var(--bg-card)', border: 'var(--border)', left: 'var(--border)' };
}

// 테이블 — 디자인 표준: 검정 머리글 띠 (stdTh 톤)
export const tableStyle    = { width: '100%', borderCollapse: 'collapse', fontSize: 12 };
export const theadRowStyle = { background: 'var(--std-thead, #0f172a)' };
export const thStyle       = { background: 'var(--std-thead, #0f172a)', padding: '10px 12px', fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.92)', borderBottom: 'none', textAlign: 'left', whiteSpace: 'nowrap', textTransform: 'uppercase', letterSpacing: '0.04em' };
export const tbodyRowStyle = { borderBottom: '1px solid var(--bg-subtle)', transition: 'background 0.1s' };
export const tdStyle       = { padding: '10px 10px', color: 'var(--text-sub)', verticalAlign: 'top' };
export const editBtnStyle  = { border: '1px solid var(--border)', borderRadius: 6, padding: '3px 10px', background: 'var(--bg-card)', color: 'var(--text-sub)', fontWeight: 700, fontSize: 11, cursor: 'pointer', marginRight: 4 };
export const deleteBtnStyle = { border: '1px solid #ef4444', borderRadius: 6, padding: '3px 10px', background: 'var(--bg-card)', color: '#dc2626', fontWeight: 700, fontSize: 11, cursor: 'pointer' };

// 모바일 카드 — 본문 카드 그림자 제거 (디자인 표준)
export const orderCardStyle = {
  background: 'var(--bg-card)', borderRadius: 12, padding: '12px 14px',
  border: '1px solid var(--border)', boxShadow: 'none',
};

// 삭제 확인 모달
export const confirmBoxStyle    = { background: 'var(--bg-card)', borderRadius: 14, width: '100%', maxWidth: 380, overflow: 'hidden', boxShadow: '0 8px 32px rgba(0,0,0,0.2)' };
// 삭제 확인 헤더 — 검정 밴드 표준 (confirmBoxStyle 라운드 14 에 맞춤, 호출처의 색 덮어쓰기 제거)
export const confirmHeaderStyle = { ...stdModalHeaderBar(14) };
export const confirmBodyStyle   = { padding: '16px 18px' };
export const confirmFooterStyle = { padding: '10px 18px 14px', display: 'flex', justifyContent: 'flex-end', gap: 8 };
export const deleteConfirmBtnStyle = { border: 'none', borderRadius: 8, padding: '7px 18px', background: '#dc2626', color: '#fff', fontWeight: 700, fontSize: 13, cursor: 'pointer' };
